module.exports = __webpack_public_path__ + "files/ffaf387a4f3bfcc4fac243f29c663658.png";